import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import { EditClientOnFacture } from './entrypoints/EditClientOnFacture';
import { EditPhotoOnDeJob } from './entrypoints/EditPhotoOnDeJob';
import { EditGenEntOnDeJob } from './entrypoints/EditGenEntOnDeJob';
import { DisplayApplicationsOnDeJob } from './entrypoints/DisplayApplicationsOnDeJob';

const entrypoints = {
    EditClientOnFacture,
    EditPhotoOnDeJob,
    EditGenEntOnDeJob,
    DisplayApplicationsOnDeJob
}

let currentRoot: ReactDOM.Root | null = null;

const keldomRender = (
  anElementId: string,
  anEntryPoint: string,
  params: any
) => {
  //We unmount a potentially existing root
  currentRoot?.unmount();
  const root = ReactDOM.createRoot(
    document.getElementById(anElementId) as HTMLElement,
  );
  const Component = (entrypoints as any)[anEntryPoint as any];
  root.render(
    <React.StrictMode>
      <Component {...params} />
    </React.StrictMode>,
  );
  currentRoot = root;
  return root;
};

(window as any).keldomRender = keldomRender;

(window as any).keldomRenderEditClientOnFacture = (factureId: number, currentCustomerId: number) => {
  keldomRender('keldom-react-root', "EditClientOnFacture", {factureId, currentCustomerId});
};
(window as any).keldomRenderEditPhotoOnDeJob = (deJobId: number, currentPhotoName: string) => {
  keldomRender('keldom-react-root', "EditPhotoOnDeJob", {deJobId, currentPhotoName});
};
(window as any).keldomRenderEditGenEntOnDeJob = (deJobId: number, currentGenEnt: number) => {
  keldomRender('keldom-react-root', "EditGenEntOnDeJob", {deJobId, currentGenEnt});
};
(window as any).keldomRenderDisplayApplicationsOnDeJob = (deJobId: number,) => {
  keldomRender('keldom-job-applications-container', "DisplayApplicationsOnDeJob", { deJobId });
};

/*
if (!(window as any).keldomExternal) {
  keldomRender('keldom-react-root', "EditClientOnFacture", {factureId: 1, currentCustomerId: 2});
}
*/
